import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab } from '@vds/tabs';
import { Badge } from '@vds/badges';
import { RadioBoxGroup } from '@vds/radio-boxes';

import TextLink from '../../common/TextLink/index';
import { isShippingTabEnabled } from '../../common/Helpers/index';
import { Body } from '../../common/Typography/index';
import { Margin } from '../../common/styles';

const ShippingTabSection = (props) => (
  <Tabs style={{ marginBottom: '30px' }} orientation="horizontal" width="50%" indicatorPosition="bottom" selectedIndex={props.isISPUselected ? 1 : 0}>
    <Tab
      label="Shipping"
      onClick={(event, tabIndex) => {
        props.changePageBottomDivToPickup(event, tabIndex);
      }}
    >
      <>
        {props.shippingOptions && (
          <Margin top="20px">
            <RadioBoxGroup
              {...props?.optionsGroupProp}
              orientation="vertical"
              data={props?.final?.map((shipping, id) => props?.getOptionData(shipping, id))}
              onChange={(event) => props?.onSelectShippingType(event)}
            />
          </Margin>
        )}
      </>
    </Tab>
    <Tab
      label="Express Pickup"
      onClick={(event, tabIndex) => {
        props.changePageBottomDivToPickup(event, tabIndex);
      }}
    >
      <>
        <div>
          {props?.shippingOptions && props?.ispuObjForRedesign?.length > 0 && props.firstTwoStoresNearBy?.length > 0 && (
            <Margin top="20px">
              <RadioBoxGroup
                {...props.optionsGroupProp}
                orientation="vertical"
                disabled
                data={
                  props?.firstTwoStoresNearBy?.length > 0 &&
                  props.firstTwoStoresNearBy?.map((shipping, id) => props?.getOptionData(shipping, id, true, props.dataSelectedFromISPUModel))
                }
                onChange={(event) => props.onSelectShippingType(event, isShippingTabEnabled(), props?.firstTwoStoresNearBy)}
              />
            </Margin>
          )}
        </div>
        <Margin top="30px">
          {(!props?.firstTwoStoresNearBy || props?.firstTwoStoresNearBy?.length === 0) && (
            <Body size="large">Sorry, there are no stores near your service address that are available for in-store pickup.</Body>
          )}
        </Margin>
      </>
      <Margin top="20px">
        <TextLink
          ariaLabel="View Cart Button"
          onClick={() => props.ISPUStoresClick()}
          onKeyPress={() => props.ISPUStoresClick()}
          analyticstrack="5G-expandedProgressbar"
          tabIndex="0"
          type="standAlone"
        >
          {!props?.firstTwoStoresNearBy || props?.firstTwoStoresNearBy?.length === 0 ? 'Select a Different Zip Code' : 'Change Store'}
        </TextLink>
      </Margin>
    </Tab>
  </Tabs>
);
ShippingTabSection.propTypes = {
  dataSelectedFromISPUModel: PropTypes.bool,
  heading: PropTypes.string,
  headingPreorder: PropTypes.string,
  gettingShippingOptionHeader: PropTypes.func,
  changePageBottomDivToPickup: PropTypes.any,
  shippingOptions: PropTypes.any,
  optionsGroupProp: PropTypes.any,
  onSelectShippingType: PropTypes.any,
  ispuObjForRedesign: PropTypes.array,
  ISPUStoresClick: PropTypes.any,
  firstTwoStoresNearBy: PropTypes.any,
  isThrottled: PropTypes.any,
  optionsGroupPropForPickup: PropTypes.any,
  getOptionData: PropTypes.any,
  final: PropTypes.any,
  toggleTileTop: PropTypes.bool,
  isISPUSelected: PropTypes.bool,
  isISPUselected: PropTypes.string,
  isFastestStore: PropTypes.bool,
};

export default React.memo(ShippingTabSection);
